import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { FlexBox } from '@dixa/lib-shared-habla';
import { useEffect, useState } from 'react';
import { FieldArray, getFormValues } from 'redux-form';
import { useAppSelector } from 'utils/redux/useAppSelector';
import { messengerAppearanceFormName } from '../../../messengerSettingsFormValueSelector';
import { messengerSettingsFormFields } from '../../../types';
import { FormSectionTitle } from '../../formSectionTitle';
import { DynamicStringsEditor, LanguageSelector, } from './components';
export function LanguageSettings({ setPreviewLanguage, }) {
    const a = useAppSelector(getFormValues(messengerAppearanceFormName));
    const defaultLanguage = a === null || a === void 0 ? void 0 : a.defaultLanguage;
    const [currentSelectedLanguage, setCurrentSelectedLanguage] = useState('en');
    useEffect(() => {
        setPreviewLanguage(currentSelectedLanguage);
    }, [setPreviewLanguage, currentSelectedLanguage]);
    return (_jsxs(FlexBox, Object.assign({ flexDirection: "column", gap: "300" }, { children: [_jsx(FormSectionTitle, { title: "Language and intro text" }), _jsxs(FlexBox, Object.assign({ gap: "500" }, { children: [_jsx(FieldArray, { name: messengerSettingsFormFields.availableLocales, component: LanguageSelector, props: {
                            defaultLanguageCode: defaultLanguage,
                            selectedLanguage: currentSelectedLanguage,
                            onSelectLanguage: setCurrentSelectedLanguage,
                        } }), _jsx(DynamicStringsEditor, { currentLangCode: currentSelectedLanguage })] }))] })));
}
